import AgInvoiceTemplate from '@/pages/invoiceManage/agInvoiceTemplate'

export default [
  {
    path: '/agInvoiceTemplate',
    name: 'AgInvoiceTemplate',
    component: AgInvoiceTemplate,
    meta: { name: '发票模板' }
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/agInvoiceTemplate.js